import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  disableAnalytics,
  enableAnalytics,
  getStoredConsent,
  storeConsent,
  updateGoogleConsent,
} from '@/lib/analytics';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = getStoredConsent();
    if (consent === 'accepted') {
      void enableAnalytics();
      return;
    }
    if (consent === 'declined') {
      disableAnalytics();
      return;
    }
    updateGoogleConsent(false);
    setVisible(true);
  }, []);

  const accept = () => {
    storeConsent(true);
    setVisible(false);
    void enableAnalytics();
  };

  const decline = () => {
    storeConsent(false);
    setVisible(false);
    disableAnalytics();
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie preferences"
      className="fixed inset-x-0 bottom-0 z-[100] p-4 sm:p-6"
    >
      <div className="mx-auto flex max-w-3xl flex-col gap-4 rounded-2xl border border-neutral-200 bg-white p-5 shadow-xl sm:flex-row sm:items-center sm:p-6">
        <p className="flex-1 text-sm leading-relaxed text-neutral-700">
          We use cookies and similar tools (Google Analytics, Google Tag Manager, and Google Ads)
          to understand how the site is used, measure advertising, and improve PetCart. Essential
          site function does not require them. See our{' '}
          <Link to="/cookie-policy" className="font-semibold text-primary underline-offset-2 hover:underline">
            Cookie Policy
          </Link>{' '}
          and{' '}
          <Link to="/privacy-policy" className="font-semibold text-primary underline-offset-2 hover:underline">
            Privacy Policy
          </Link>
          .
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            onClick={decline}
            className="inline-flex h-10 items-center justify-center rounded-md border border-neutral-300 px-4 text-sm font-semibold text-neutral-700 transition-colors hover:bg-neutral-50"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={accept}
            className="inline-flex h-10 items-center justify-center rounded-md bg-primary px-4 text-sm font-semibold text-white transition-colors hover:bg-primary/90"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
